import { render, staticRenderFns } from "./AppUserProjectActivities.vue?vue&type=template&id=35d7baeb&scoped=true"
import script from "./AppUserProjectActivities.vue?vue&type=script&lang=js"
export * from "./AppUserProjectActivities.vue?vue&type=script&lang=js"
import style0 from "./AppUserProjectActivities.vue?vue&type=style&index=0&id=35d7baeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d7baeb",
  null
  
)

export default component.exports